<template>
  <Admin>
    <Skills
      v-if="user.role.name == 'School Admin'"
      :school-id="user.school_id"
    ></Skills>
    <div v-else class="pa-4">
      <v-card>
        <v-card-title>
          Schools
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="schools"
          :search="search"
          class="elevation-1"
        >
          <template v-slot:item.actions="{ item }">
            <v-btn small color="primary" @click="openSkillsModal(item)">
              View Skills
            </v-btn>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="dialog" max-width="1200px" @click:outside="closeDialog">
        <v-card v-if="selectedSchoolId">
          <v-card-title class="headline">
            Skills for {{ selectedSchoolName }}
            <v-spacer></v-spacer>
            <v-btn icon @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <Skills :key="selectedSchoolId" :school-id="selectedSchoolId"></Skills>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </Admin>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Admin from "../layouts/Admin";
import Skills from "../components/Skills";

export default {
  components: { Admin, Skills },
  data() {
    return {
      search: "",
      dialog: false,
      selectedSchoolId: null,
      selectedSchoolName: "",
      headers: [
        { text: "School Name", value: "name" },
        { text: "Actions", value: "actions", sortable: false, align: "right" },
      ],
    };
  },
  computed: {
    ...mapGetters("school", ["schools"]),
    ...mapGetters("auth", ["user"]),
  },
  methods: {
    ...mapActions("school", ["fetchAllSchools"]),
    ...mapActions("skill", ["fetchSkills"]),
    openSkillsModal(school) {
      this.selectedSchoolId = school.id;
      this.selectedSchoolName = school.name;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.selectedSchoolId = null;
        this.selectedSchoolName = "";
      }, 300); // clear after animation
    }
  },
  mounted() {
    this.fetchAllSchools();
    this.fetchSkills();
  },
};
</script>

<style scoped>
</style>